module.exports = __webpack_public_path__ + "img/huairou.a5f8008d.png";